// Type definitions for Apache Cordova CodePush plugin.
// Project: https://github.com/Microsoft/cordova-plugin-code-push
//
// Copyright (c) Microsoft Corporation
// All rights reserved.
// Licensed under the MIT license.
import { registerPlugin } from "@capacitor/core";
export const CodePush = /*#__PURE__*/ registerPlugin("CodePush");
//# sourceMappingURL=nativeCodePushPlugin.js.map